import React, { useState, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import useBookingApp from "../../../../hooks/useBookingApp";
import { setSelectedPrivateService, updateBookingField } from "../../../../dispatchers/bookingDispatchers";

export default function ANRightContent({
    setBookingForm,
    setVaccinessNoticesStep,
    mainColor,
}) {
    const { bookingSectionState } = useBookingApp();
    const { companyServices, selectedPrivateService } = bookingSectionState;
    const [selectedService, setSelectedService] = useState("");

    const serviceData = [
        { serviceId: 1, title: "Travel Vaccine" },
        { serviceId: 2, title: "Weight Loss" },
        { serviceId: 3, title: "Malaria Prevention" },
    ];

    useEffect(() => {
        if (companyServices && companyServices.length > 0) {
            const firstServiceId = companyServices[0]._id;
            setSelectedPrivateService(firstServiceId);
        }
    }, [companyServices]);

    const handleChange = (event) => {
        const selectedId = event.target.value;
        setSelectedPrivateService(selectedId);
        updateBookingField({ field: "ServiceId", value: selectedId });
    };

    return (
        <div className="inner-content vn-right">
            <p className="section-title">Services</p>

            <FormControl fullWidth style={{ marginTop: 16 }}>
                <InputLabel id="service-select-label">Select a Service</InputLabel>
                <Select
                    labelId="service-select-label"
                    value={selectedPrivateService}
                    label="Select a Service"
                    onChange={handleChange}
                >
                    {companyServices?.map((service) => (
                        <MenuItem key={service._id} value={service._id}>
                            {service.serviceName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
